// Input validation utilities for security

export const validateLocation = (location) => {
  if (!location || typeof location !== 'string') {
    throw new Error('Location must be a non-empty string');
  }
  
  const trimmed = location.trim();
  if (trimmed.length === 0) {
    throw new Error('Location cannot be empty');
  }
  
  if (trimmed.length > 100) {
    throw new Error('Location name too long');
  }
  
  // Basic sanitization - remove potentially dangerous characters
  const sanitized = trimmed.replace(/[<>\"'&]/g, '');
  return sanitized;
};

export const validateCoordinates = (lat, lon) => {
  const latitude = parseFloat(lat);
  const longitude = parseFloat(lon);
  
  if (isNaN(latitude) || isNaN(longitude)) {
    throw new Error('Invalid coordinates');
  }
  
  if (latitude < -90 || latitude > 90) {
    throw new Error('Latitude must be between -90 and 90');
  }
  
  if (longitude < -180 || longitude > 180) {
    throw new Error('Longitude must be between -180 and 180');
  }
  
  return { lat: latitude, lon: longitude };
};

export const validateTemperature = (temp) => {
  const temperature = parseFloat(temp);
  
  if (isNaN(temperature)) {
    throw new Error('Invalid temperature value');
  }
  
  // Reasonable temperature range check (-100°C to 70°C)
  if (temperature < -100 || temperature > 70) {
    throw new Error('Temperature out of reasonable range');
  }
  
  return temperature;
};

export const sanitizeString = (input) => {
  if (typeof input !== 'string') {
    return '';
  }
  
  // Remove potentially dangerous characters and limit length
  return input
    .trim()
    .replace(/[<>\"'&]/g, '')
    .substring(0, 1000);
};